import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import AnimateHeight from 'react-animate-height';
import { Box } from '../Box/index.js';

/**
 * The Collapse component is used to create regions of content that can
 * expand/collapse with a simple animation. It helps to hide content that's
 * not immediately relevant to the user.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/collapse#usage)
 * - [Props](https://blockparty.endpoint.com/components/collapse#props)
 * <br />
 *
 */
const Collapse = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    animateOpacity = true,
    duration = 200,
    easing = 'ease',
    endingHeight = 'auto',
    isOpen,
    startingHeight = 0,
    dataTestId = 'collapse',
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(AnimateHeight, {
    animateOpacity: animateOpacity,
    duration: duration,
    easing: easing,
    height: isOpen ? endingHeight : startingHeight
  }, /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    "data-test-id": dataTestId
  }, rest), children));
});
Collapse.displayName = 'Collapse';

export { Collapse };
